import $ from 'jquery'
import styles from './constants/map-styles'

const backgroundColor = '#101010'
const API_KEY = 'AIzaSyBbU6g2cm4E1ogCN8QqSHIzt-SD6lcPjgI'
const $maps = $('[data-map-canvas]')
const maps = []

const theme = $('body').data('page-theme')
const iconsBase64 = {
  default:
    'PHN2ZyBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iNjUiIGhlaWdodD0iNjUiIHZpZXdCb3g9IjAgMCA2NSA2NSI+DQoJPHBhdGggZD0iTTIyLjE3LDYuNTloOS41M1YyMS4wOWEzLjc1LDMuNzUsMCwwLDAsMCw3LjM1VjQ3Ljg0bC0yLjU0LTMuMTktNC44NS02LjA5SDIzdjFsNC4wOCw1LjEyLDQuODUsNi4wOSwwLjYsMC43NiwwLjYyLS43Niw1LTYuMDksNC4wNy01VjM4LjU1SDQxbC01LDYuMDlMMzMuMzEsNDhWMjguNGEzLjc0LDMuNzQsMCwwLDAsMC03LjI3VjYuNThoOS41MlY1SDIyLjE3VjYuNTlaIiBmaWxsPSIjRkYyMDQ1Ii8+DQoJPHJlY3QgeD0iMjIuMTciIHk9IjEuMzIiIHdpZHRoPSIyMC42NyIgaGVpZ2h0PSIxLjYyIiBmaWxsPSIjRkYyMDQ1Ii8+DQoJPHBvbHlnb24gcG9pbnRzPSIzNi4wNCA1MC43NCAzNC45IDUyLjEzIDMyLjU1IDU1LjAxIDMwLjI2IDUyLjEzIDI5LjE2IDUwLjc0IDI0LjMxIDQ0LjY1IDIzLjAxIDQ0LjY1IDIzLjAxIDQ1LjYyIDI3LjA4IDUwLjc0IDI4LjE5IDUyLjEzIDMyLjUzIDU3LjU5IDM3IDUyLjEzIDM4LjEzIDUwLjc0IDQyLjIgNDUuNzcgNDIuMiA0NC42NSA0MS4wMiA0NC42NSAzNi4wNCA1MC43NCIgZmlsbD0iI0ZGMjA0NSIvPg0KCTxwb2x5Z29uIHBvaW50cz0iMzkuODggNTIuMTMgMzQuOSA1OC4yMyAzMi41NSA2MS4xIDMwLjI2IDU4LjIzIDI1LjQxIDUyLjEzIDI0LjMxIDUwLjc0IDIzLjAxIDUwLjc0IDIzLjAxIDUxLjcxIDIzLjM0IDUyLjEzIDI4LjE5IDU4LjIzIDMyLjUzIDYzLjY5IDM3IDU4LjIzIDQxLjk4IDUyLjEzIDQyLjIgNTEuODcgNDIuMiA1MC43NCA0MS4wMiA1MC43NCAzOS44OCA1Mi4xMyIgZmlsbD0iI0ZGMjA0NSIvPg0KPC9zdmc+',
  golden:
    'PHN2ZyBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iNjUiIGhlaWdodD0iNjUiIHZpZXdCb3g9IjAgMCA2NSA2NSI+Cgk8cGF0aCBkPSJNMjIuMTcsNi41OWg5LjUzVjIxLjA5YTMuNzUsMy43NSwwLDAsMCwwLDcuMzVWNDcuODRsLTIuNTQtMy4xOS00Ljg1LTYuMDlIMjN2MWw0LjA4LDUuMTIsNC44NSw2LjA5LDAuNiwwLjc2LDAuNjItLjc2LDUtNi4wOSw0LjA3LTVWMzguNTVINDFsLTUsNi4wOUwzMy4zMSw0OFYyOC40YTMuNzQsMy43NCwwLDAsMCwwLTcuMjdWNi41OGg5LjUyVjVIMjIuMTdWNi41OVoiIGZpbGw9IiNiZThjMDAiLz4KCTxyZWN0IHg9IjIyLjE3IiB5PSIxLjMyIiB3aWR0aD0iMjAuNjciIGhlaWdodD0iMS42MiIgZmlsbD0iI2JlOGMwMCIvPgoJPHBvbHlnb24gcG9pbnRzPSIzNi4wNCA1MC43NCAzNC45IDUyLjEzIDMyLjU1IDU1LjAxIDMwLjI2IDUyLjEzIDI5LjE2IDUwLjc0IDI0LjMxIDQ0LjY1IDIzLjAxIDQ0LjY1IDIzLjAxIDQ1LjYyIDI3LjA4IDUwLjc0IDI4LjE5IDUyLjEzIDMyLjUzIDU3LjU5IDM3IDUyLjEzIDM4LjEzIDUwLjc0IDQyLjIgNDUuNzcgNDIuMiA0NC42NSA0MS4wMiA0NC42NSAzNi4wNCA1MC43NCIgZmlsbD0iI2JlOGMwMCIvPgoJPHBvbHlnb24gcG9pbnRzPSIzOS44OCA1Mi4xMyAzNC45IDU4LjIzIDMyLjU1IDYxLjEgMzAuMjYgNTguMjMgMjUuNDEgNTIuMTMgMjQuMzEgNTAuNzQgMjMuMDEgNTAuNzQgMjMuMDEgNTEuNzEgMjMuMzQgNTIuMTMgMjguMTkgNTguMjMgMzIuNTMgNjMuNjkgMzcgNTguMjMgNDEuOTggNTIuMTMgNDIuMiA1MS44NyA0Mi4yIDUwLjc0IDQxLjAyIDUwLjc0IDM5Ljg4IDUyLjEzIiBmaWxsPSIjYmU4YzAwIi8+Cjwvc3ZnPg==',
}
const iconBase64 = theme in iconsBase64 ? iconsBase64[theme] : iconsBase64.default

export function init() {
  if (!$maps.length) return
  loadScript('https://maps.googleapis.com/maps/api/js?v=3&key=' + API_KEY, () => {
    $maps.each((i, elem) => {
      const $map = $(elem)
      const config = $map.data('map-canvas')
      console.log(config)
      const { location } = config
      const position = new google.maps.LatLng(location.lat, location.lng)
      const mapOptions = {
        styles,
        center: position,
        zoom: location.zoom || 12,
        draggable: !('ontouchend' in document && $(window).width <= 1024),
        backgroundColor: backgroundColor,
        panControl: true,
        zoomControl: true,
        scaleControl: true,
        scrollwheel: false,
        mapTypeControl: false,
        streetViewControl: false,
        overviewMapControl: false,
      }
      const map = new google.maps.Map($map[0], mapOptions)

      const marker = new google.maps.Marker({
        map,
        position,
        icon: 'data:image/svg+xml;base64,' + iconBase64,
      })

      maps.push({
        map,
        $map,
        config,
        marker,
      })
    })
  })
}

function loadScript(src, callback) {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  if (callback) script.onload = callback
  $('head')[0].appendChild(script)
  script.src = src
}
